var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBadge(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "sale",
    transform: "translate(-0.002 -0.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6645",
    "data-name": "Path 6645",
    d: "M47.594,26.223a2.955,2.955,0,0,1,0-2.442l1.865-4.1a6.075,6.075,0,0,0-3.4-8.205L41.843,9.889a2.94,2.94,0,0,1-1.727-1.727L38.532,3.945a6.075,6.075,0,0,0-8.205-3.4l-4.1,1.865a2.939,2.939,0,0,1-2.442,0L19.677.546a6.075,6.075,0,0,0-8.205,3.4L9.889,8.162A2.94,2.94,0,0,1,8.161,9.889L3.944,11.473a6.075,6.075,0,0,0-3.4,8.205l1.865,4.1a2.955,2.955,0,0,1,0,2.442l-1.865,4.1a6.075,6.075,0,0,0,3.4,8.205l4.217,1.584a2.94,2.94,0,0,1,1.727,1.727l1.584,4.217a6.08,6.08,0,0,0,8.205,3.4l4.1-1.865a2.939,2.939,0,0,1,2.442,0l4.1,1.865a6.075,6.075,0,0,0,8.205-3.4l1.584-4.217a2.94,2.94,0,0,1,1.727-1.727l4.217-1.584a6.075,6.075,0,0,0,3.4-8.205Z",
    transform: "translate(0 0)",
    fill: "#f44336"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3442",
    "data-name": "Group 3442",
    transform: "translate(11.27 10.165)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6646",
    "data-name": "Path 6646",
    d: "M17.58,10.416a4.691,4.691,0,0,0-6.634,6.634L13.894,20a4.691,4.691,0,1,0,6.634-6.634Zm.738,7.37a1.564,1.564,0,0,1-2.212,0l-2.948-2.948a1.568,1.568,0,0,1,0-2.212,1.565,1.565,0,0,1,2.21,0l2.948,2.948a1.566,1.566,0,0,1,0,2.212Z",
    transform: "translate(-0.901 -0.373)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6647",
    "data-name": "Path 6647",
    d: "M12.511,12.415A1.564,1.564,0,1,0,10.3,14.628l2.579,2.579-2.212,2.214L8.085,16.84a1.564,1.564,0,1,0-2.212,2.212l7.372,7.372a1.563,1.563,0,0,0,2.21-2.212l-2.579-2.579,2.212-2.214L17.667,22a1.563,1.563,0,0,0,2.21-2.212Z",
    transform: "translate(-5.414 2.788)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6648",
    "data-name": "Path 6648",
    d: "M24.742,14.928,18.475,8.661,19.58,7.556a1.564,1.564,0,0,0-2.212-2.212L15.16,7.553l0,0,0,0L12.943,9.77a1.563,1.563,0,1,0,2.21,2.212l1.105-1.107,6.267,6.267a1.566,1.566,0,0,0,2.216-2.214Z",
    transform: "translate(2.258 -4.885)",
    fill: "#fafafa"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_6649",
    "data-name": "Path 6649",
    d: "M22.139,18.823l-2.212,2.212,1.547,1.547a1.563,1.563,0,1,0,2.21-2.212Zm14.2-14.2L29.511,11.45l3.759,3.759a1.563,1.563,0,1,1-2.21,2.212L27.3,13.66l-2.95,2.95L25.9,18.157a4.691,4.691,0,0,1-6.634,6.634l-1.547-1.547-.738.738,3.759,3.759a1.563,1.563,0,1,1-2.21,2.212l-2.579-2.579-2.212,2.214,2.579,2.579a1.563,1.563,0,1,1-2.21,2.212l-3.759-3.759L4.625,36.34a2.9,2.9,0,0,1,.252.517l1.585,4.22a6.084,6.084,0,0,0,8.211,3.4l4.105-1.866A2.954,2.954,0,0,1,20,42.347a2.921,2.921,0,0,1,1.22.265l4.105,1.866a6.081,6.081,0,0,0,8.213-3.4l1.585-4.22a2.942,2.942,0,0,1,1.728-1.728l4.22-1.585a6.079,6.079,0,0,0,3.4-8.211l-1.866-4.105a2.956,2.956,0,0,1,0-2.444l1.866-4.105a6.079,6.079,0,0,0-3.4-8.211l-4.22-1.585A3.625,3.625,0,0,1,36.335,4.626Z",
    transform: "translate(4.983 4.979)",
    fill: "#d43a2f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6650",
    "data-name": "Path 6650",
    d: "M17.538,10.374l-2.212,2.212,1.547,1.547A1.565,1.565,0,0,1,15.768,16.8a1.551,1.551,0,0,1-1.105-.459L13.116,14.8,10.9,17.01l1.547,1.547a4.691,4.691,0,0,0,6.634-6.634Z",
    transform: "translate(11.81 11.233)",
    fill: "#dadada"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6651",
    "data-name": "Path 6651",
    d: "M14,13.909,7.369,20.543,11.128,24.3a1.563,1.563,0,0,0,2.21-2.212l-2.579-2.579L12.971,17.3l2.579,2.579a1.563,1.563,0,0,0,2.21-2.212Z",
    transform: "translate(7.98 15.061)",
    fill: "#dadada"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6652",
    "data-name": "Path 6652",
    d: "M17.712,7.9,15.5,10.109l3.759,3.759a1.563,1.563,0,0,0,2.21-2.212Z",
    transform: "translate(16.791 8.554)",
    fill: "#dadada"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBadge);
export default __webpack_public_path__ + "static/media/badge.0d033f04725d6ddbad0182749aaed691.svg";
export { ForwardRef as ReactComponent };